
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface InventoryHeaderProps {
  onAddItem: () => void;
}

export function InventoryHeader({ onAddItem }: InventoryHeaderProps) {
  const { t } = useTranslation(["inventory", "common"]);
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col sm:flex-row justify-between sm:items-center space-y-2 sm:space-y-0">
      <div>
        <h2 className={`font-bold tracking-tight ${isMobile ? "text-lg" : "text-2xl"}`}>{t('title')}</h2>
        <p className={`text-muted-foreground ${isMobile ? "text-xs" : ""}`}>{t('subtitle')}</p>
      </div>
      <Button 
        onClick={onAddItem} 
        size={isMobile ? "xs" : "default"}
      >
        <PlusCircle className={`${isMobile ? "h-3 w-3" : "h-4 w-4"} mr-1`} />
        {t('addItem')}
      </Button>
    </div>
  );
}
